import AuthenticationHelper from '../helpers/AuthenticationHelper'
import UserProfileHelper from '../helpers/UserProfileHelper'
import UserMatchHelper from '../helpers/UserMatchHelper'
import UserInteractionHelper from '../helpers/UserInteractionHelper'

class testAPI{

    //run test function for user interaction
    async runInteractionProfileTestSuite(){
        if (await AuthenticationHelper.login("test2","test2"))
        {
            console.group("Authentication")
            console.log("Login successful "+AuthenticationHelper.token)
            console.log("decoded claims id: "+ AuthenticationHelper.uuid)
            console.groupEnd()
        }

       //test get current user recieved Hugs
        console.group("User Hugs")
        const userHugs= await UserInteractionHelper.getHugsRecievedByUserId(AuthenticationHelper.uuid)
        console.log(userHugs)
        const userHugsSent= await UserInteractionHelper.getHugsSentByUserId("8884937f-93a3-4759-8b51-bb77fd8ae7b8")
        console.log(userHugsSent)
        const userHugNo =await UserInteractionHelper.getHuggedNoByUserId(AuthenticationHelper.uuid)
        console.log(userHugNo)

        const addHugresult = await UserInteractionHelper.addHug(AuthenticationHelper.uuid,"025bbfc8-102f-4730-9a56-6476ff928330")
        console.log(addHugresult)

        const removeHugresult = await UserInteractionHelper.removeHug(AuthenticationHelper.uuid,"025bbfc8-102f-4730-9a56-6476ff928330")
        console.log(removeHugresult)

        console.groupEnd()

       //test get current user support messages
       console.group("User Support messages")
       const userSupportMsg= await UserInteractionHelper.getSupportMsgRecievedByUserId(AuthenticationHelper.uuid)
       console.log(userSupportMsg)
       const userSupportMsgSent= await UserInteractionHelper.getSupportMsgSentByUserId("8884937f-93a3-4759-8b51-bb77fd8ae7b8")
       console.log(userSupportMsgSent)
       const userSupportMsgNo =await UserInteractionHelper.getRecievedSupportMsgNoByUserId(AuthenticationHelper.uuid)
       console.log(userSupportMsgNo)

       const addSupportMsgResult = await UserInteractionHelper.addSupportMsg(AuthenticationHelper.uuid,"025bbfc8-102f-4730-9a56-6476ff928330","Hi, I feel for your lost")
       console.log(addSupportMsgResult)
       const removeSupportMsgResult = await UserInteractionHelper.removeSupportMsg(AuthenticationHelper.uuid,"025bbfc8-102f-4730-9a56-6476ff928330")
       console.log(removeSupportMsgResult)
       console.groupEnd()


       //test get current user contacts
       console.group("User Contacts")
       const userContacts= await UserInteractionHelper.getContactByUserId(AuthenticationHelper.uuid)
       console.log(userContacts)
       const addContactResult = await UserInteractionHelper.addContact(AuthenticationHelper.uuid,"025bbfc8-102f-4730-9a56-6476ff928330")
       console.log(addContactResult)
       const removeContactResult = await UserInteractionHelper.removeContact(AuthenticationHelper.uuid,"025bbfc8-102f-4730-9a56-6476ff928330")
       console.log(removeContactResult)         
       console.groupEnd()
       

       AuthenticationHelper.resetToken()
       console.log("logging out")
    }

    //run test functions for user profiles
    async runUserProfileTestSuite(){
         if (await AuthenticationHelper.login("test2","test2"))
         {
             console.group("Authentication")
             console.log("Login successful "+AuthenticationHelper.token)
             console.log("decoded claims id: "+ AuthenticationHelper.uuid)
             console.groupEnd()
         }

        //test get current user profile
         console.group("User profile")
         const user= await UserProfileHelper.getProfileById(AuthenticationHelper.uuid)
         console.table(user)
         const userAll =await UserProfileHelper.getAllProfiles()
         console.log(userAll)
         console.groupEnd()

        //test edit user profile
        const userObj = {
            "displayName": 'Test User 2 Edited',
            "relationship": 'Other',
            "gender": 'Male',
            "state": 'HA',
            "lossExperience": 'We are testing the update function. If it works, then we are genius.'
        }
        const editResult = await UserProfileHelper.updateProfileById(AuthenticationHelper.uuid, userObj)
        console.log(editResult.addedData)

        //test recommended user list
         console.group("Recommended user list")
         const recUserList = await UserMatchHelper.getRecProfile(AuthenticationHelper.uuid,10)
         console.log(recUserList)
         console.groupEnd()

        AuthenticationHelper.resetToken()
        console.log("logging out")

        //test register new profile 
        /*
        console.group("Register new user")
        const result = await UserProfileHelper.registerUser(
            {
                "username": "test8",
                "password": "test6", 
                "displayName": "tester8",
                "age": "80",
                "relationship": "aunt",
                "gender":"male",
                "state":"New york",
                "lossExperience": "it is a painful lost"
            }
        )
        console.log(result)
        console.groupEnd()
        */
    }

    /*test test reset password  */
    async runSendResetPasswordEmailTest(email){
        console.group("Testing send reset password email")
        const emailresetpasswordresult= await UserProfileHelper.sendresetPasswordEmail(email)
        console.log(emailresetpasswordresult)
        console.groupEnd()
    }

    async runResetPasswordEmailTest(username,password){

        if (await AuthenticationHelper.login("test2","test2"))
        {
            console.group("Authentication")
            console.log("Login successful "+AuthenticationHelper.token)
            console.log("decoded claims id: "+ AuthenticationHelper.uuid)
            console.groupEnd()
        }

       console.group("Testing reset password")
       const resetpasswordresult= await UserProfileHelper.resetPassword(username,password)
       console.log(resetpasswordresult)
       console.groupEnd()
       
       AuthenticationHelper.resetToken()
       console.log("logging out")
    }

    async runTestIfUserIsResetingPassword(username,password){

        if (await AuthenticationHelper.login(username,password))
        {
            console.group("Authentication")
            console.log("Login successful "+AuthenticationHelper.token)
            console.log("decoded claims id: "+ AuthenticationHelper.uuid)
            console.groupEnd()
        }

       console.group("Getting User status")
       const status= await UserProfileHelper.getRoleById(AuthenticationHelper.uuid)
       console.log(status)
       if (status.data.status ===2)
       {
           alert("User is reseting password")
       }
       console.groupEnd()
       
       AuthenticationHelper.resetToken()
       console.log("logging out")
    }

}
 

export default new testAPI()